import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "./WhatsAppFloat";
import { Loader } from "./Loader";
import { ChatBot } from "../common/ChatBot";

export const Layout = () => {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen bg-cream-50">
      <Loader />
      <Navbar />
      <motion.main
        key={pathname}
        initial={{ opacity: 0, y: 44 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <Outlet />
      </motion.main>
      <Footer />
      <WhatsAppFloat />
      <ChatBot />
    </div>
  );
};
